import { getAuth, onAuthStateChanged } from "firebase/auth";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Navbar from "./navbar";

function TutorHome() {
  const navigate = useNavigate();
  const thisUser = useSelector((state) => state.thisUser.user);
  const thisTutor = useSelector((state) => state.thisTutor.thisTutor);

  const [user, setUser] = useState(null);

  useEffect(() => {
    const auth = getAuth();
    onAuthStateChanged(auth, (user) => {
      if (user) {
        setUser(user);
      }
    });
  });
  const getCardAnimation = () => {
    if (
      document.getElementById("tutor-home-card-right") &&
      document.getElementById("tutor-home-card-left")
    ) {
      document.getElementById("tutor-home-card-right").style.transform =
        "scale(1)";
      document.getElementById("tutor-home-card-left").style.transform =
        "scale(1)";
    }
  };

  useEffect(() => {
    setTimeout(() => {
      getCardAnimation();
    }, 200);
  }, [thisUser, user]);

  return (
    <>
      <Navbar user={user} />
      <div className="flex justify-center items-center flex-col mb-10">
        <p className="text-[1.7em] md:text-[2em] font-semibold text-gray-700 mb-10 md:mb-20 m-10">
          {thisTutor
            ? `Hi ${thisTutor?.firstName}, what are you here for?`
            : thisUser
            ? `Hi ${thisUser?.firstName}, what are you here for?`
            : "Hi, what are you here for?"}
        </p>
        <div className="flex justify-center items-center flex-wrap gap-10">
          <div
            className="flex flex-col border-[1px] shadow-lg p-8 rounded-md bg-white w-[18em] md:w-[27em] justify-center items-center scale-[0.001] transition-all duration-[650ms] ease-in-out"
            id="tutor-home-card-left"
          >
            <img
              src="review.svg"
              className="w-[10em] md:w-[15em] md:h-[18em] scale-[.85]"
              alt="review illustration"
            />
            <p className="text-gray-700 font-medium text-[.9em] min-h-[7em]">
              Let's post a feedback to support your tutor. By posting a
              feedback, you agree that your feedback will publicly be displayed
              on the app.
            </p>
            <button
              className="p-3 text-white rounded-md font-semibold bg-black mt-5 hover:scale-105 transition-all duration-400 ease-linear"
              onClick={() => {
                navigate("/review-tutor");
              }}
            >
              Submit a Review
            </button>
          </div>
          <div
            className="flex flex-col border-[1px] shadow-lg p-8 rounded-md bg-white w-[18em] md:w-[27em] justify-center items-center scale-[0.001] transition-all duration-[780ms] ease-linear"
            id="tutor-home-card-right"
          >
            <img
              src="tutorSignup.svg"
              className="w-[10em] md:w-[15em] md:h-[18em]"
              alt="review illustration"
            />
            <p className="text-gray-700 font-medium text-[.9em] min-h-[7em]">
              Fill out your information to sign up and get listed on the app
              upon approval (it might take a few days to review your
              application). We need smart people like you!
            </p>
            <button
              className="p-3 text-white rounded-md font-semibold bg-black mt-5 hover:scale-105 transition-all duration-400 ease-linear"
              onClick={() => {
                navigate("/become-tutor");
              }}
            >
              Become a Tutor
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default TutorHome;
